import { ApiService } from "../../../constants/ApiService";
import { HttpService } from "../../../constants/HTTPService";

export const getMasterQuestionnaire = async () => {
  const data = HttpService.get(ApiService.questionnaire.getMasterQuestionnaire);
  const dataAPI = (await data).data;

  return dataAPI;
};

export const SubmitQuestionnaire = async (
  binusianId?: string,
  requestID?: string,
  trQuestionnaire?: string
) => {
  const data = HttpService.post(
    ApiService.questionnaire.submitQuestionnaire,
    JSON.stringify({
      BinusianId: binusianId,
      RequestID: requestID,
      TrQuestionnaire: trQuestionnaire,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};

export const CheckAccessUserQuestionaire = async (
  binusianId?: string,
  requestID?: string
) => {
  const data = HttpService.post(
    ApiService.questionnaire.checkAccessUserQuestionaire,
    JSON.stringify({
      BinusianId: binusianId,
      RequestID: requestID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};
